module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "note-editor"
    }
  }, [_c('textarea', {
    staticClass: "form-control",
    on: {
      "input": function($event) {
        _vm.edit(_vm.activeNote)
      }
    }
  }, [_vm._v(_vm._s(_vm.activeNote.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ee42c01a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor.vue
// module id = 13
// module chunks = 0